import SupportHomePage from "../components/support/SupportHomePage";

function SupportPage() {
  return <SupportHomePage />;
}

export default SupportPage;
